import { render, staticRenderFns } from "./NavTab.vue?vue&type=template&id=80ac470a&scoped=true"
import script from "./NavTab.vue?vue&type=script&lang=js"
export * from "./NavTab.vue?vue&type=script&lang=js"
import style0 from "./NavTab.vue?vue&type=style&index=0&id=80ac470a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80ac470a",
  null
  
)

export default component.exports